import './LoginPage.scss';

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as LogoImage } from '@assets/images/logo_icon.svg';
import Button from '@components/Button';
import { useInjection } from '@src/components/Injection';
import { RoutePath } from '@src/constants/route-path';
import { useAuth } from '@src/contexts/authContext';
import { auth } from '@src/firebase/firebase';
import { CLIENT_SERVICE, ClientService } from '@src/services/client.service';
import { doSignInWithEmailAndPassword } from '../firebase/auth';

const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

function LoginPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const emailValue = e.target.value;
    setEmail(emailValue);
    setIsEmailValid(validateEmail(emailValue));
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const clientService = useInjection<ClientService>(CLIENT_SERVICE);
  const { initializeUser } = useAuth();

  const handleSubmit = async (e: React.FormEvent, initUser) => {
    e.preventDefault();
    try {
      await doSignInWithEmailAndPassword(email, password);

      await initUser(auth.currentUser, clientService);

      setError(null);
      navigate(RoutePath.PatientListPage);
    } catch (err) {
      setError('Failed to sign in. Please check your credentials.');
      console.log(err);
    }
  };

  return (
    <div className="modLoginForm">
      <div className="modLoginForm__box">
        <LogoImage className="modLoginForm__logo" />
        <div className="modLoginForm__title">Welcome back</div>
        <div className="modLoginForm__subtitle">Log in to manage your patients and orders</div>
        <form onSubmit={(e) => handleSubmit(e, initializeUser)} className="modLoginForm__form">
          <div className="modLoginForm__inputName">Email:</div>
          <input
            className={`modLoginForm__input ${!isEmailValid ? 'invalid' : ''}`}
            type="email"
            value={email}
            onChange={handleEmailChange}
          />
          {!isEmailValid && <p style={{ color: 'red' }}>Please enter a valid email address.</p>}
          <div className="modLoginForm__inputName">Password:</div>
          <div className="modLoginForm__passwordInput">
            <input
              className="modLoginForm__input"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={handlePasswordChange}
            />
            <button type="button" className="modLoginForm__passwordToggle" onClick={togglePasswordVisibility}>
              {showPassword ? 'Hide' : 'Show'}
            </button>
          </div>
          <div className="modLoginForm__inputName"></div>
          {error && <p style={{ color: 'red', paddingBottom: '0.5rem' }}>{error}</p>}
          <Button type="submit" fullWidth={true}>
            Log in
          </Button>
        </form>
        <div className="modLoginForm__signUp">
          Don&apos;t have an account yet? <a href="/signup">Sign up</a>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
